/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";

// @mui material components
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";

import { CustomToastContent } from "../../../examples/CustomToastContent/index";

// import Icon from "@mui/material/Icon";
import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// React-Select component and styling
import Select from "react-select";

//  config file
import Config from "../../../config/index";

// Functions from store
import {
  getWarehouses,
  getReturns,
  getItemMaster,
  getZonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getSubModulesByRoleId,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getAcn,
  createReturns,
  uploadForReturnsValue,
  getRelationLocation,
  getWarehousesByMovement,
  deleteReturn,
  editReturns,
  getLevelsByWarehouse,
  getDppDocumentsImage,
  getDppIds,
  getRepairCenter,
  getDynamicColumn,
  createDynamicColumn,
} from "../../../store";

// Cookies
import Cookies from "universal-cookie";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import { addMinutes, format } from "date-fns";
import { Backdrop } from "@mui/material";
import MDInput from "components/MDInput";
import { CSVLink } from "react-csv";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import DownloadButton from "components/standardized-components/DownloadButton";

const cookies = new Cookies();

const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 850 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflowX: "hidden",
  overflowY: "scroll",
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  maxHeight: "90%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 850 },
  boxShadow: 24,
  p: 1,
  pt: 3,
  overflowX: "hidden",
  overflowY: "scroll",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Returns = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  createDynamicColumn,
  getWarehouses,
  deleteReturn,
  warehouses,
  getReturns,
  getReturnsReducer,
  getItemMaster,
  dppIdSelectedForGlobalFilter,
  getDynamicColumn,
  itemMaster,
  getZonesByWarehouse,
  zonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocationReducer,
  getLevel1ByLevel,
  getWarehouseByMovementReducer,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel4ByLevel,
  getLevel4ByLevelReducer,
  editReturns,
  getDppDocumentsImageReducer,
  getDppDocumentsImage,
  getAcn,
  getAcnReducer,
  getDppIds,
  getRelationLocation,
  createReturns,
  getWarehousesByMovement,
  uploadForReturnsValue,
  getLevelsByWarehouse,
  getDPPReducer,
  levelsByWarehouseReducer,
  getRepairCenterReducer,
  getRepairCenter,

  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : []
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "6e1939a2-039d-4a29-8e00-728b8bfed0aa"
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "c23e1710-f6b4-4869-9855-98764f2d875c"
    )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "deca5b06-12bf-4e49-9459-4a394b036da2"
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "d8ffda1e-7189-4093-af3f-e94e44596905"
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "a48a60f8-dd6f-489e-9d55-b2c9342b95bf"
    )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [warehouseIdSelected, setWarehouseIdSelected] = useState("");
  const [returnCodeUpdateSelected, setreturnCodeUpdateSelected] = useState("");
  const [returnStatusSelected, setreturnStatusSelected] = useState("");
  const [returnCodeSelected, setReturnCodeSelected] = useState("");
  const [zoneIdSelected, setZoneIdSelected] = useState("");
  const [sectionIdSelected, setSectionIdSelected] = useState("");
  const [rackIdSelected, setRackIdSelected] = useState("");
  const [locationIdSelected, setLocationIdSelected] = useState("");
  const [activityIdSelected, setActivityIdSelected] = useState("");

  const handleActivityIdChange = (selectedActivity) => {
    setActivityIdSelected(selectedActivity);
    setWarehouseIdSelected("");
  };

  // console.log("returnCodeUpdateSelected", returnCodeUpdateSelected);

  const handleChangeWarehouse = (selectedData) => {
    setWarehouseIdSelected(selectedData);
    setZoneIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleChangeReturnStatus = (selectedData) => {
    setreturnStatusSelected(selectedData);
  };
  const handleChangeReturnUpdateCode = (selectedData) => {
    setreturnCodeUpdateSelected(selectedData);
  };
  const handleChangeReturnCode = (selectedData) => {
    setReturnCodeSelected(selectedData);
  };
  const [RepairCenterSelected, setRepairCenterSelected] = useState("");
  const handleChangeRepairCenter = (selectedData) => {
    setRepairCenterSelected(selectedData);
  };
  const [RepairCenterSelectedUpdate, setRepairCenterSelectedUpdate] = useState("");
  const handleChangeRepairCenterUpdate = (selectedData) => {
    setRepairCenterSelectedUpdate(selectedData);
  };

  const handleZoneIDChange = (selectedRack) => {
    setZoneIdSelected(selectedRack);
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleSectionIdChange = (selectedRack) => {
    setSectionIdSelected(selectedRack);
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleRackIdChange = (selectedRack) => {
    setRackIdSelected(selectedRack);
    setLocationIdSelected("");
  };

  const handleLocationIdChange = (selectedLocation) => {
    setLocationIdSelected(selectedLocation);
  };

  // useEffect(() => {
  //   getReturns(jwtToken);
  // }, []);

  const [selectedZoneName, setSelectedZoneName] = useState("");

  const handleZoneNameChange = (selectedZoneName) => {
    setSelectedZoneName(selectedZoneName);
    setRackIdSelected("");
  };

  const [dppIdSelected, setdppIdSelected] = useState("");

  const handleChangeDpp = (selectedData) => {
    setdppIdSelected(selectedData);
  };

  useEffect(() => {
    if (dppIdSelectedForGlobalFilter) {
      setdppIdSelected(dppIdSelectedForGlobalFilter);
    }
  }, [dppIdSelectedForGlobalFilter]);

  useEffect(() => {
    if (dppIdSelectedForGlobalFilter?.value) {
      // Fetch with dppId + jwtToken
      getReturns(dppIdSelectedForGlobalFilter?.value, jwtToken);
    } else {
      // Fetch without filter
      getReturns(null, jwtToken);
    }
  }, [dppIdSelectedForGlobalFilter, jwtToken]);

  const [dppOptions, setDPPOptions] = useState([]);

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getDPPReducer.dpp.data ? getDPPReducer.dpp.data : [];
    data.map((zone) => {
      tempgetDPPReducer.push({
        label: zone.dppCode,
        value: zone.dppId,
        industryId: zone.industryId,  
        industryName: zone.industryName,
      });
    });
    setDPPOptions(tempgetDPPReducer);
  }, [getDPPReducer]);

  const [dppIdForUpdateSelected, setdppIdForUpdateSelected] = useState("");
  const handleChangeDppForUpdate = (selectedData) => {
    setdppIdForUpdateSelected(selectedData);
  };
  useEffect(() => {
    getDppIds(jwtToken);
  }, []);
  useEffect(() => {
    getRepairCenter(jwtToken);
  }, []);


  const [currentFile, setCurrentFile] = useState(null);


  const handleOpenDocument = (item) => {

    const type = item.type;
    const name = item.name;
    const moduleName = item.moduleName;




    getDppDocumentsImage(
      moduleName,
      type,
      name,
      jwtToken
    );
  };

  useEffect(() => {
    const data = getDppDocumentsImageReducer.documents.data;

    if (data) {
      // Set the file for temporary use
      setCurrentFile(data);

      // Reset local state in reducer copy
      getDppDocumentsImageReducer.documents.data = null; // clears it locally
    }
  }, [getDppDocumentsImageReducer.documents.data]);


  useEffect(() => {
    if (currentFile) {
      const timer = setTimeout(() => setCurrentFile(null), 1000); // 5 seconds
      return () => clearTimeout(timer);
    }
  }, [currentFile]);

  // Open file whenever currentFile updates
  useEffect(() => {
    if (!currentFile) return;

    let fileUrl;
    if (typeof currentFile === "string") fileUrl = currentFile;
    else if (currentFile.url) fileUrl = currentFile.url;
    else if (currentFile.base64) {
      const byteCharacters = atob(currentFile.base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: currentFile.type || "application/octet-stream",
      });
      fileUrl = URL.createObjectURL(blob);
    } else return;

    window.open(fileUrl, "_blank", "noopener,noreferrer");
  }, [currentFile]);


  const suitabilityOptions = [
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  const durationUnitOptions = [
    { label: "days", value: "days" },
    { label: "weeks", value: "weeks" },
    { label: "months", value: "months" },
    { label: "years", value: "years" },
  ];

  const [state, setState] = useState({
    columns: [
      { Header: "Return Id", accessor: "returnId" },
      { Header: "DPP Code", accessor: "dppCode" },
      // { Header: "Return Date", accessor: "zone" },
      {
        Header: "Return Date",
        accessor: "returnDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(new Date(value), "dd/MM/yyyy")
            : "";
        },
      },
      { Header: "Reason", accessor: "reasonCode" },
      { Header: "Repair Center", accessor: "repairCenterId" },
      {
        Header: "repair Status",
        accessor: "repairStatus",
        cannotSearch: true,
        cannotSort: true,
      },
      { Header: "Final Disposition", accessor: "finalDisposition" },
      // { Header: "repair Centers", accessor: "repairCenters" },
      { Header: "average RepairTime", accessor: "averageRepairTime" },
      { Header: "spareParts Availability", accessor: "sparePartsAvailability" },
      { Header: "common Repairs", accessor: "commonRepairs" },
      { Header: "maintenance Schedule", accessor: "maintenanceSchedule" },
      { Header: "Second Life Suitability", accessor: "isSecondLifeSuitable" },
      { Header: "remark", accessor: "remark" },


      // { Header: "Created By", accessor: "acnCode" },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  // const headers = [
  //   { label: "returnId", key: "returnId" },
  //   { label: "dppCode", key: "dppCode" },
  //   { label: "returnDate", key: "createdDate" },
  //   { label: "reasonCode", key: "reasonCode" },
  //   { label: "repairCenterId", key: "repairCenterId" },
  //   { label: "repairStatus", key: "repairStatusValue" },
  //   { label: "finalDisposition", key: "finalDisposition" },
  //   // { label: "repairCenters", key: "repairCenters" },
  //   { label: "averageRepairTime", key: "averageRepairTime" },
  //   { label: "sparePartsAvailability", key: "sparePartsAvailability" },
  //   { label: "commonRepairs", key: "commonRepairs" },
  //   { label: "maintenanceSchedule", key: "maintenanceSchedule" },
  //   // { Header: "Second Life Suitability", accessor: "isSecondLifeSuitableValue" },
  //   // { Header: "Second Life Duration", accessor: "secondLifeDuration" },
  //   // { label: "remark", key: "remark" },

  // ];

  // const headersForTemp = [
  //   { label: "dppCode", key: "dppCode" },
  //   { label: "returnDate", key: "returnDate" },
  //   { label: "reasonCode", key: "reasonCode" },
  //   { label: "repairCenterId", key: "repairCenterId" },
  //   { label: "repairActions", key: "repairActions" },
  //   { label: "reusedParts", key: "reusedParts" },
  //   { label: "finalDisposition", key: "finalDisposition" },
  //   { label: "repairCenters", key: "repairCenters" },
  //   { label: "averageRepairTime", key: "averageRepairTime" },
  //   { label: "sparePartsAvailability", key: "sparePartsAvailability" },
  //   { label: "commonRepairs", key: "commonRepairs" },
  //   { label: "maintenanceSchedule", key: "maintenanceSchedule" },
  //   { label: "orderNo", key: "orderNo" },
  // ];


  // --- 1. Table Data Download (Listing) ke Headers ---
  // Note: Maine "Return Date" ki key "createdDate" aur "Repair Status" ki key "repairStatusValue" 
  // wahi rakhi hai jo purane code mein thi, taaki aapke table ka data properly map ho sake.


  const headers = [
    { label: "DPP Code", key: "dppCode" },
    { label: "Return Date", key: "createdDate" },
    { label: "Reason Code", key: "reasonCode" },
    { label: "Repair Center", key: "repairCenter" },
    { label: "Repair Status", key: "repairStatusValue" },
    { label: "Final Disposition", key: "finalDisposition" },
    { label: "Average Repair Time", key: "averageRepairTime" },
    { label: "Spare Parts Availability", key: "sparePartsAvailability" },
    { label: "Common Repairs", key: "commonRepairs" },
    { label: "Maintenance Schedule", key: "maintenanceSchedule" },
    { label: "Remark", key: "remark" }

    // { label: "Return ID", key: "returnId" },
  ];

  const headersForTemp = [
    { label: "dppCode", key: "dppCode" },
    { label: "returnDate", key: "returnDate" },
    { label: "reasonCode", key: "reasonCode" },
    { label: "repairCenter", key: "repairCenter" },
    { label: "repairStatus", key: "repairStatus" },

    { label: "repairActions", key: "repairActions" },
    { label: "reusedParts", key: "reusedParts" },
    { label: "finalDisposition", key: "finalDisposition" },
    { label: "averageRepairTime", key: "averageRepairTime" },
    { label: "sparePartsAvailability", key: "sparePartsAvailability" },
    { label: "commonRepairs", key: "commonRepairs" },
    { label: "maintenanceSchedule", key: "maintenanceSchedule" },
    { label: "remark", key: "remark" }
  ];


  const { columns, rows } = state;

  const csvLink = {
    filename: "Returns List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Returns Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempMappedActivity = [];
    let data = getReturnsReducer.return.data
      ? getReturnsReducer.return.data
      : [];
    // setPaginationObj(getReturnsReducer?.mappedActivity?.pagination);
    setLoading(getReturnsReducer.loading);

    data.map((item) => {
      const formatDate = new Date(item.returnDate);
      let itemDescription = item.itemDescription;
      let len = desLength;

      const itemObject = {
        privateKey: item.itemCode,
        itemCodeDes: `${item.itemCode} / ${itemDescription ? itemDescription.substring(0, len) : ""
          }`,
        returnId: item.returnId,
        dppCode: item.dppCode,
        returnId: item.returnId,
        finalDisposition: item.finalDisposition,
        repairCenterId: item.serviceCenterName,
        reasonCode: item.reasonCode,
        itemCode: item.itemCode,
        returnDate: item.returnDate,

        repairCenters: item.repairCenters,
        averageRepairTime: item.averageRepairTime,
        sparePartsAvailability: item.sparePartsAvailability,
        commonRepairs: item.commonRepairs,
        remark: item.remark,
        maintenanceSchedule: item.maintenanceSchedule,
        isSecondLifeSuitable: item.isSecondLifeSuitable,

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {item?.itemDescription?.length > 35 ? (
              <Tooltip
                title={item.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {item.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {item.itemDescription}
              </MDTypography>
            )}
            {item?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        repairStatus: (
          <button
            type="button"
            className={
              (item.repairStatus === 0 && `status-warning`) ||
              (item.repairStatus === 1 && `status-info`) ||
              (item.repairStatus === 2 && `status-success`) ||
              (item.repairStatus === 3 && `status-error`)
            }
            style={{ width: "7rem", cursor: "pointer" }}
          >
            {(item.repairStatus === 0 && `Pending`) ||
              (item.repairStatus === 1 && `In-Progress`) ||
              (item.repairStatus === 2 && `Completed`) ||
              (item.repairStatus === 3 && `Cancelled`)}
          </button>
        ),

        repairStatusValue:
          item.repairStatus === 0
            ? "Pending"
            : item.repairStatus === 1
              ? "In-Progress"
              : item.repairStatus === 2
                ? "Completed"
                : item.repairStatus === 3
                  ? "Cancelled"
                  : "",

        id: item.id,
        categoryCode: item.categoryCode,
        warehouse: item.warehouseCode,
        zone: item.zone,
        section: item.section,

        createdDate: format(new Date(formatDate), "dd/MM/yyyy"),
        cd: item.cd,
        rack: item.rack,
        location: item.location,
        // itemName: des ? des.substring(0, len) : "",
        acnCode: item.acnCode,

        action: (

          <>
            {deleteAccess && (
              <Tooltip title='Attachment'>
                <MDButton
                  tooltip="Attachment"
                  variant="gradient"
                  color="info"
                  iconOnly
                  disabled={item.moduleName==null}
                  size="small"
                  style={{ paddingl: "0px", marginRight: "4px", minWidth: "26px" }}
                  onClick={() => handleOpenDocument(item)}
                >
                  <Icon>description</Icon>
                </MDButton>
              </Tooltip>
            )}

            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}

            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => {
                  handleOpenUpdateModal(item);
                }}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    viewAccess && setState({ ...state, rows: tempMappedActivity });
  }, [getReturnsReducer]);

  const activeDataOptions = [
    { label: "Pending", value: "0" },
    { label: "In-Progress", value: "1" },
    { label: "Completed", value: "2" },
    { label: "Cancelled", value: "3" },
  ];
  const activeReasonOptions = [
    { label: "Warranty", value: "Warranty" },
    { label: "Upgrade", value: "Upgrade" },
    { label: "Defect", value: "Defect" },
    { label: "Other", value: "Other" },
  ];
  //   const activeDataOptions = [
  //   {  label: "Completed", value: "0" },
  //   {  label: "In-Progress", value: "1" },
  //   {  label: "Cancelled", value: "2" },
  //   {  label: "Pending", value: "3" },
  // ];

  const [activityOptions, setActivityOptions] = useState([]);

  useEffect(() => {
    let tempActivityOptions = [];
    let data = getAcnReducer.acn.data ? getAcnReducer.acn.data : [];
    data.map((activity) => {
      tempActivityOptions.push({
        label: activity.acnName,
        value: activity.acnId,
      });
    });
    setActivityOptions(tempActivityOptions);
  }, [getAcnReducer]);

  const [repairCenterOptions, setRepairCenterOptionsOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = getRepairCenterReducer.return.data ? getRepairCenterReducer.return.data : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.serviceCenterName,
        value: warehouse.repairCenterId,
      });
    });
    setRepairCenterOptionsOptions(tempWarehouseOptions);
  }, [getRepairCenterReducer]);

  const [warehouseOptionsByMovement, setWarehouseOptionsByMovement] = useState(
    []
  );

  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = getWarehouseByMovementReducer.warehouses.data
      ? getWarehouseByMovementReducer.warehouses.data
      : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptionsByMovement(tempWarehouseOptions);
  }, [getWarehouseByMovementReducer]);
  // useEffect(() => {
  //   let tempLevelOptions = [];
  //   let data = getRelationLocationReducer.locations.data
  //     ? getRelationLocationReducer.locations.data
  //     : [];

  //   data.map((level) => {
  //     tempLevelOptions.push({
  //       label: level.rltName,
  //       value: level.rltLevel,
  //     });
  //   });
  //   setLevelOptions(tempLevelOptions);
  // }, [getRelationLocationReducer]);

  // let level1Name = getRelationLocationReducer.locations.data

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [zoneOptions, setZoneOptions] = useState([]);

  useEffect(() => {
    let tempZonesByWarehouse = [];
    let data = zonesByWarehouse.zones.data ? zonesByWarehouse.zones.data : [];
    data.map((zone) => {
      tempZonesByWarehouse.push({
        label: zone.zoneName,
        value: zone.id,
      });
    });
    setZoneOptions(tempZonesByWarehouse);
  }, [zonesByWarehouse]);

  // useEffect(() => {
  //   getLevelsByWarehouse(warehouseIdSelected?.value, jwtToken);
  // }, [warehouseIdSelected]);

  const [levelOptions, setLevelOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = levelsByWarehouseReducer.levelsByWarehouse.data
      ? levelsByWarehouseReducer.levelsByWarehouse.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rltName,
        value: level?.rltLevel,
      });
    });
    setLevelOptions(tempLevelOptions);
  }, [levelsByWarehouseReducer]);

  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);

  const [openBinsOptions, setOpenBinsOptions] = useState([]);

  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
    setZoneIdSelected("");
    setWarehouseIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleCloseAllocateItemModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
    setAllocateItemModal(!allocateItemModal);
    setReturnCodeSelected("");
    formik.setErrors({});
    setdppIdSelected("");
    setWarehouseIdSelected("");
    setLocationIdSelected("");
    setActivityIdSelected("");
    setSelectedItemCode("");
    setRepairCenterSelected("")
    setRepairCenterSelectedUpdate("")

    formik.setValues(initialValues);
    // resetForm()
  };

  const [ActivityMappingData, setActivityMappingData] = useState({});

  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [selectedBin, setSelectedBin] = useState("");

  const handleBinChange = (selectedBin) => {
    setSelectedBin(selectedBin);
  };
  const [selectedBinForAdd, setSelectedBinForAdd] = useState("");

  const handleBinChangeForAdd = (selectedBinForAdd) => {
    setSelectedBinForAdd(selectedBinForAdd);
  };

  const [selectedOpenBin, setSelectedOpenBin] = useState(
    ActivityMappingData?.locationName
  );

  useEffect(() => {
    if (ActivityMappingData) {
      setSelectedOpenBin({
        label: ActivityMappingData?.locationName,
        value: ActivityMappingData?.locationName,
      });
    }
  }, [ActivityMappingData]);

  const handleOpenBinChange = (selectedOpenBin) => {
    setSelectedOpenBin(selectedOpenBin);
  };

  //  dppId:values.DPPId,
  //     returnDate:values.ReturnDate,
  //     reasonCode:values.ReasonCode,
  //     repairCenterId:values.RepairCenterId,
  //     repairStatus:warehouseIdSelected?.value,
  //     repairActions:values.RepairActions,
  //     reusedParts:values.ReusedParts,
  //     finalDisposition:values.FinalDisposition,

  const initialValues = {
    DPPID: "",
    ReturnDate: "",
    ReturnCode: "",
    RepairCenter: "",
    RepairStatus: "",
    RepairActions: "",
    FinalDisposition: "",
    ReusedParts: "",
    averageRepairTime: "",
    sparePartsAvailability: "",
    commonRepairs: "",
    maintenanceSchedule: "",

    isSecondLifeSuitable: null,
    secondLifeDurationNumber: "",
    secondLifeDurationUnit: durationUnitOptions[0],
    reuseDeclarationFile: null,
  };


  const today = new Date().toISOString().split("T")[0];

  // const validationSchema = Yup.object({

  //   ReturnDate: Yup.date()
  //     .required(" ")
  //     .min(today, "ReturnDate cannot be a past date"),

  //   ReturnCode: Yup.object().required(" "),
  //   RepairStatus: Yup.object().required(" "),
  //   RepairCenter: Yup.object().required(" "),
  //   RepairActions: Yup.string().trim().required(" "),
  //   FinalDisposition: Yup.string().trim().required(" "),
  //   ReusedParts: Yup.string().trim().required(" "),
  //   averageRepairTime: Yup.string().trim().required(" "),
  //   sparePartsAvailability: Yup.string().trim().required(" "),
  //   commonRepairs: Yup.string().trim().required(" "),
  //   maintenanceSchedule: Yup.string().trim().required(" "),

  //   isSecondLifeSuitable: Yup.mixed().nullable().required(" "),


  // });

  // Dynamic Schema Function based on industryId
  
  const getValidationSchema = (industryId) => {
    const id = Number(industryId); 
    const today = new Date().toISOString().split("T")[0];

    return Yup.object({ 
      DPPID: id === 9 
        ? Yup.mixed().nullable().required(" ") 
        : Yup.mixed().nullable(),

      ReturnDate: id === 9 
        ? Yup.date().required(" ").min(today, "ReturnDate cannot be a past date")
        : Yup.date().nullable(),

      ReturnCode: id === 9 ? Yup.object().nullable().required(" ") : Yup.object().nullable(),
      RepairCenter: id === 9 ? Yup.object().nullable().required(" ") : Yup.object().nullable(),
      RepairStatus: id === 9 ? Yup.object().nullable().required(" ") : Yup.object().nullable(),

      FinalDisposition: id === 9 ? Yup.string().trim().required(" ") : Yup.string().trim(),
      averageRepairTime: id === 9 ? Yup.string().trim().required(" ") : Yup.string().trim(),
      sparePartsAvailability: id === 9 ? Yup.string().trim().required(" ") : Yup.string().trim(),
      commonRepairs: id === 9 ? Yup.string().trim().required(" ") : Yup.string().trim(),
      maintenanceSchedule: id === 9 ? Yup.string().trim().required(" ") : Yup.string().trim(),
      remark: id === 9 ? Yup.string().trim().required(" ") : Yup.string().trim(),

 
      RepairActions: Yup.string().trim(),
      ReusedParts: Yup.string().trim(),
      isSecondLifeSuitable: Yup.mixed().nullable(),
    });
  };


  const [errorMsg, setErrorMsg] = useState("");

  const [allocateButtonName, setAllocateButtonName] = useState("Create");


  const onSubmit = async (values, { resetForm }) => {

    // if (values.isSecondLifeSuitable?.value === 1) {
    //       let hasError = false;

    //       if (!values.secondLifeDurationNumber) {
    //         // setFieldError("secondLifeDurationNumber", "Required");
    //         hasError = true;
    //       }
    //       if (!values.reuseDeclarationFile) {
    //         // setFieldError("reuseDeclarationFile", "File is required");
    //         hasError = true;
    //       } 
    //       if (hasError) return; 
    //     }
    setAllocateButtonName("Please wait...");

    const formData = new FormData();

    formData.append("cdBy", userId);
    formData.append("dppId", dppIdSelected?.value || "");
    formData.append("returnDate", values.ReturnDate || "");
    formData.append("repairCenterId", RepairCenterSelected?.value || "");

    formData.append("repairStatus", warehouseIdSelected?.value || "");
    formData.append("reasonCode", returnCodeSelected?.value || "");
    formData.append("repairActions", values.RepairActions || "");
    formData.append("reusedParts", values.ReusedParts || "");
    formData.append("finalDisposition", values.FinalDisposition || "");
    formData.append("averageRepairTime", values.averageRepairTime || "");
    formData.append("sparePartsAvailability", values.sparePartsAvailability || "");
    formData.append("commonRepairs", values.commonRepairs || "");
    formData.append("remark", values.remark || "");
    formData.append("maintenanceSchedule", values.maintenanceSchedule || "");
    formData.append("moduleName", values.returnRepairInfo || "returnRepairInfo");

    if (values.isSecondLifeSuitable) {
      formData.append("isSecondLifeSuitable", values.isSecondLifeSuitable.value);

      if (values.isSecondLifeSuitable.value === 1) {
        const combinedDuration = `${values.secondLifeDurationNumber} ${values.secondLifeDurationUnit?.value || "days"}`;
        formData.append("secondLifeDuration", combinedDuration);
      }

      if (values.isSecondLifeSuitable.value === 0 && values.reuseDeclarationFile) {
        formData.append("file", values.reuseDeclarationFile);
        formData.append("documentType", "secondLifeReuseDecalration");
      }
    }

    let res = await createReturns(formData, jwtToken);

    if (res.status) {
      setIsSuccessAllocateItem(true);
      // getOpenBinsByWarehouseAndZone(warehouseIdSelected?.value, zoneIdSelected);
      getReturns(dppIdSelectedForGlobalFilter?.value, jwtToken);
      formik.setErrors({});

      // Resetting states
      setActivityIdSelected("");
      setWarehouseIdSelected("");
      setReturnCodeSelected("");
      setLocationIdSelected("");

      setTimeout(() => {
        setAllocateButtonName("Create");
        handleCloseAllocateItemModal();
      }, 2250);
    }

    if (!res.status) {
      setErrorMsg(res?.data?.data?.msg || "Something went wrong");
      setAllocateButtonName("Create");
      setIsErrorAllocateItem(true);
    }
  };

  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleOpenDeleteModal = (data) => {
    setOpenDeleteModal(true);
    setSingleDataForDelete(data);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const [isErrorDeleteAssembly, setIsErrorDeleteAssembly] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState(false);
  const [isSuccessForAssembly, setIsSuccessForAssembly] = useState(false);

  useEffect(() => {
    if (isErrorDeleteAssembly) {
      setTimeout(() => {
        setIsErrorDeleteAssembly(false);
      }, 3000);
    }
  }, [isErrorDeleteAssembly]);
  useEffect(() => {
    if (isSuccessForAssembly) {
      setTimeout(() => {
        setIsSuccessForAssembly(false);
      }, 2000);
    }
  }, [isSuccessForAssembly]);

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteTripNo = async () => {
    setDeleteButtonName("Please wait...");
    let returnId = singleDataForDelete.returnId;
    // let userId = singleDataForDelete.userId;

    let res = await deleteReturn(returnId, userId);

    if (res.status) {
      getReturns(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 3000);
      setIsSuccessForAssembly(true);
    }

    if (!res.status) {
      setIsErrorDeleteAssembly(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
      setDeleteButtonName("Delete");
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    // validationSchema,
    validationSchema: () => getValidationSchema(dppIdSelected?.industryId),
  });

  const [isSuccessAddActivityMapping, setIsSuccessAddActivityMapping] =
    useState(false);
  const [isErrorAddActivityMapping, setIsErrorAddActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessAddActivityMapping) {
      setTimeout(() => {
        setIsSuccessAddActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessAddActivityMapping]);

  useEffect(() => {
    if (isErrorAddActivityMapping) {
      setTimeout(() => {
        setIsErrorAddActivityMapping(false);
      }, 3000);
    }
  }, [isErrorAddActivityMapping]);

  const [addActivityMappingModal, setAddActivityMappingModal] = useState(false);
  const handleAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };
  const handleCloseAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };

  const initialValueForAddActivityMapping = {
    bin: "",
  };

  const validationSchemaForAddActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForAddActivityMapping = async (values, { resetForm }) => {
    const payload = {
      warehouseId: warehouseIdSelected?.value,
      itemId: ActivityMappingData.itemId,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedBinForAdd.value,
    };

    setSelectedBinForAdd("");
    resetForm();
  };

  const formikForAdd = useFormik({
    initialValues: initialValueForAddActivityMapping,
    validationSchema: validationSchemaForAddActivityMapping,
    onSubmit: onSubmitForAddActivityMapping,
  });

  const [isSuccessEditActivityMapping, setIsSuccessEditActivityMapping] =
    useState(false);
  const [isErrorEditActivityMapping, setIsErrorEditActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessEditActivityMapping) {
      setTimeout(() => {
        setIsSuccessEditActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessEditActivityMapping]);

  useEffect(() => {
    if (isErrorEditActivityMapping) {
      setTimeout(() => {
        setIsErrorEditActivityMapping(false);
      }, 3000);
    }
  }, [isErrorEditActivityMapping]);

  const [editActivityMappingModal, setEditActivityMappingModal] =
    useState(false);
  const handleEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };

  const handleCloseEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };
  const initialValueForEditActivityMapping = {
    bin: "",
  };

  const validationSchemaForEditActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForEditActivityMapping = async (values, reset) => {
    const payload = {
      itemId: ActivityMappingData.itemId,
      warehouseId: warehouseIdSelected?.value,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedOpenBin?.value,
    };

    // let res = await editBinAllocation(payload, jwtToken);

    // if (res.status) {
    //   setIsSuccessEditActivityMapping(true);
    //   getReturns(warehouseIdSelected?.value, jwtToken);
    // }
    // if (!res.status) {
    //   setIsErrorEditActivityMapping(true);
    // }
    // setSelectedOpenBin("");
  };
  const formikForEdit = useFormik({
    initialValues: initialValueForEditActivityMapping,
    validationSchema: validationSchemaForEditActivityMapping,
    onSubmit: onSubmitForEditActivityMapping,
    enableReinitialize: true,
  });

  const [warehouseTypesSelectedForEdit, setWarehouseTypesSelectedForEdit] =
    useState("");
  const [itemCodeSelectedForEdit, setItemCodeSelectedForEdit] = useState("");
  const [acnTypeSelectedForEdit, setAcnTypeSelectedForEdit] = useState("");
  const [zoneSelectedForEdit, setZoneSelectedForEdit] = useState("");
  const [sectionSelectedForEdit, setSectionSelectedForEdit] = useState("");
  const [rackSelectedForEdit, setRackSelectedForEdit] = useState("");
  const [locationSelectedForEdit, setLocationSelectedForEdit] = useState("");

  const [singleFgDataForUpdate, setSingleFgDataForUpdate] = useState({});
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const handleOpenUpdateModal = (singleData) => {
    setreturnCodeUpdateSelected({
      label: singleData.reasonCode,
      value: singleData.reasonCode,

    });

    setdppIdForUpdateSelected({
      label: singleData.dppCode, 
      value: singleData.dppId,
      industryId: singleData.industryId,  
    });

    setRepairCenterSelectedUpdate({
      label: singleData.serviceCenterName,
      value: singleData.repairCenterId,
    });

    // setreturnStatusSelected({
    //   label: singleData.section,
    //   value: singleData.sectionId,
    // });

    setreturnStatusSelected({
      label:
        (singleData.repairStatus === 0 && "Pending") ||
        (singleData.repairStatus === 1 && "In-Progress") ||
        (singleData.repairStatus === 2 && "Completed") ||
        (singleData.repairStatus === 3 && "Cancelled"),
      value: singleData.repairStatus.toString(),
    });

    setLocationSelectedForEdit({
      label: singleData.location,
      value: singleData.locationId,
    });
    setSingleFgDataForUpdate(singleData);
    setOpenUpdateModal(true);

    // getWarehousesByMovement(
    //   acnTypeSelectedForEdit?.value,

    //   jwtToken
    // );
  };

  const handleChangeWarehouseForEdit = (selectedOption) => {
    setWarehouseTypesSelectedForEdit(selectedOption);
    setZoneSelectedForEdit("");
  };
  const handleChangeAcnForEdit = (selectedOption) => {
    setAcnTypeSelectedForEdit(selectedOption);
  };
  const handleChangeZoneForEdit = (selectedOption) => {
    setZoneSelectedForEdit(selectedOption);
    setSectionSelectedForEdit("");
  };
  const handleChangeSectionForEdit = (selectedOption) => {
    setSectionSelectedForEdit(selectedOption);
    setRackSelectedForEdit("");
  };
  const handleChangeRackForEdit = (selectedOption) => {
    setRackSelectedForEdit(selectedOption);
    setLocationSelectedForEdit("");
  };
  const handleChangeLocationForEdit = (selectedOption) => {
    setLocationSelectedForEdit(selectedOption);
  };

  // dppId:values.DPPID,
  // returnDate:values.ReturnDate,
  // repairCenterId:values.RepairCenterId,
  // repairStatus:warehouseIdSelected?.value,
  // reasonCode:returnCodeSelected?.value,
  // repairActions:values.RepairActions,
  // reusedParts:values.ReusedParts,
  // finalDisposition:values.FinalDisposition,

  // const initialValueForUpdate = {
  //   DPPID: singleFgDataForUpdate.dppCode,
  //   ReturnDate: singleFgDataForUpdate.returnDate
  //     ? (() => {
  //       const [month, day, year] =
  //         singleFgDataForUpdate.returnDate.split("/");
  //       return `${year}-${month}-${day}`;
  //     })()
  //     : "",

  //   // ReturnDate: singleFgDataForUpdate.returnDate ,
  //   RepairCenterID: singleFgDataForUpdate.repairCenterId,
  //   RepairActions: singleFgDataForUpdate.repairActions,
  //   RepairActions: singleFgDataForUpdate.repairActions,
  //   ReusedParts: singleFgDataForUpdate.reusedParts,
  //   FinalDisposition: singleFgDataForUpdate.finalDisposition,
  //   repairCenters: singleFgDataForUpdate.repairCenters,
  //   averageRepairTime: singleFgDataForUpdate.averageRepairTime,
  //   sparePartsAvailability: singleFgDataForUpdate.sparePartsAvailability,
  //   commonRepairs: singleFgDataForUpdate.commonRepairs,
  //   remark: singleFgDataForUpdate.remark,
  //   maintenanceSchedule: singleFgDataForUpdate.maintenanceSchedule,

  // };



  let parsedDurationNum = "";
  let parsedDurationUnit = durationUnitOptions[0];

  if (singleFgDataForUpdate.secondLifeDuration) {
    const parts = singleFgDataForUpdate.secondLifeDuration.split(" ");
    parsedDurationNum = parts[0] || "";

    const unitStr = parts[1] ? parts[1].toLowerCase() : "";
    parsedDurationUnit = durationUnitOptions.find(opt =>
      opt.value.includes(unitStr)
    ) || durationUnitOptions[0];
  }

  let suitabilityOpt = null;
  const suitVal = singleFgDataForUpdate.isSecondLifeSuitable;
  if (suitVal === "Yes" || suitVal === 1 || String(suitVal) === "1") {
    suitabilityOpt = suitabilityOptions.find(opt => opt.value === 1);
  } else if (suitVal === "No" || suitVal === 0 || String(suitVal) === "0") {
    suitabilityOpt = suitabilityOptions.find(opt => opt.value === 0);
  }

  const initialValueForUpdate = {
    DPPID: singleFgDataForUpdate.dppCode || "",
    ReturnDate: singleFgDataForUpdate.returnDate
      ? (() => {
        const [month, day, year] = singleFgDataForUpdate.returnDate.split("/");
        return `${year}-${month}-${day}`;
      })()
      : "",

    RepairCenterID: singleFgDataForUpdate.repairCenterId || "",
    RepairActions: singleFgDataForUpdate.repairActions || "",
    ReusedParts: singleFgDataForUpdate.reusedParts || "",
    FinalDisposition: singleFgDataForUpdate.finalDisposition || "",
    repairCenters: singleFgDataForUpdate.repairCenters || "",
    averageRepairTime: singleFgDataForUpdate.averageRepairTime || "",
    sparePartsAvailability: singleFgDataForUpdate.sparePartsAvailability || "",
    commonRepairs: singleFgDataForUpdate.commonRepairs || "",
    remark: singleFgDataForUpdate.remark || "",
    maintenanceSchedule: singleFgDataForUpdate.maintenanceSchedule || "",


    isSecondLifeSuitable: suitabilityOpt,
    secondLifeDurationNumber: parsedDurationNum,
    secondLifeDurationUnit: parsedDurationUnit,
    reuseDeclarationFile: null,
  };

  const handleCloseModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [editButtonName, setEditButtonName] = useState("Update");

  // const onSubmitForUpdate = async (values) => {
  //   setEditButtonName("Please wait...");
  //   let payload = {
  //     udBy: userId,
  //     returnId: singleFgDataForUpdate?.returnId,
  //     //  dppId:values.DPPID,
  //     returnDate: values.ReturnDate,
  //     // repairCenterId: values.RepairCenterID,

  //     repairCenterId: RepairCenterSelectedUpdate?.value,
  //     repairStatus: returnStatusSelected?.value,
  //     reasonCode: returnCodeUpdateSelected?.value,
  //     repairActions: values.RepairActions,
  //     reusedParts: values.ReusedParts,
  //     finalDisposition: values.FinalDisposition,
  //     repairCenters: values.repairCenters,
  //     averageRepairTime: values.averageRepairTime,
  //     sparePartsAvailability: values.sparePartsAvailability,
  //     commonRepairs: values.commonRepairs,
  //     remark: values.remark,
  //     maintenanceSchedule: values.maintenanceSchedule,
  //   };
  //   let res = await editReturns(payload, jwtToken);
  //   if (res.status) {
  //     setIsSuccessForUpdate(true);
  //     getReturns(dppIdSelectedForGlobalFilter?.value, jwtToken);
  //     setTimeout(() => {
  //       handleCloseModal();
  //       setEditButtonName("Update");
  //     }, 3000);
  //   }
  //   if (!res.status) {
  //     setIsErrorForUpdate(true);
  //     setErrorMsgForUpdate(res?.data?.data?.msg);
  //     setEditButtonName("Update");
  //   }
  // };

  // Dhyan dein: setFieldError ko destructure kiya hai manual validation ke liye
  const onSubmitForUpdate = async (values, { setFieldError }) => {

    if (values.isSecondLifeSuitable?.value === 1) {
      let hasError = false;
      if (!values.secondLifeDurationNumber) {
        setFieldError("secondLifeDurationNumber", "Required");
        hasError = true;
      }
      if (hasError) return;
    }

    setEditButtonName("Please wait...");

    let formData = new FormData();

    formData.append("udBy", userId);
    formData.append("returnId", singleFgDataForUpdate?.returnId || "");
    formData.append("returnDate", values.ReturnDate || "");
    formData.append("repairCenterId", RepairCenterSelectedUpdate?.value || "");
    formData.append("repairStatus", returnStatusSelected?.value || "");
    formData.append("reasonCode", returnCodeUpdateSelected?.value || "");
    formData.append("repairActions", values.RepairActions || "");
    formData.append("reusedParts", values.ReusedParts || "");
    formData.append("finalDisposition", values.FinalDisposition || "");
    formData.append("repairCenters", values.repairCenters || "");
    formData.append("averageRepairTime", values.averageRepairTime || "");
    formData.append("sparePartsAvailability", values.sparePartsAvailability || "");
    formData.append("commonRepairs", values.commonRepairs || "");
    formData.append("remark", values.remark || "");
    formData.append("maintenanceSchedule", values.maintenanceSchedule || "");

    formData.append("moduleName", "returnRepairInfo");

    if (values.isSecondLifeSuitable) {
      formData.append("isSecondLifeSuitable", values.isSecondLifeSuitable.value);

      if (values.isSecondLifeSuitable.value === 1) {
        const combinedDuration = `${values.secondLifeDurationNumber} ${values.secondLifeDurationUnit?.value || "days"}`;
        formData.append("secondLifeDuration", combinedDuration);

        if (values.reuseDeclarationFile) {
          formData.append("file", values.reuseDeclarationFile);
          formData.append("documentType", "secondLifeReuseDecalration");
        }
      }
    }

    let res = await editReturns(formData, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getReturns(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseModal();
        setEditButtonName("Update");
      }, 3000);
    }

    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg || "Something went wrong");
      setEditButtonName("Update");
    }
  };


  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForAssembly,
    validationSchema: () => getValidationSchema(singleFgDataForUpdate?.industryId),
    enableReinitialize: true,
  });

  const [isErrorDeleteActivityMapping, setIsErrorDeleteActivityMapping] =
    useState(false);
  useEffect(() => {
    if (isErrorDeleteActivityMapping) {
      setTimeout(() => {
        setIsErrorDeleteActivityMapping(false);
      }, 3000);
    }
  }, [isErrorDeleteActivityMapping]);

  const [openDeleteActivityMappingModal, setOpenDeleteActivityMappingModal] =
    useState(false);

  const handleOpenDeleteActivityMappingModal = (data = {}) => {
    setActivityMappingData(data);
    setOpenDeleteActivityMappingModal(true);
  };

  const handleCloseDeleteActivityMappingModal = () => {
    setOpenDeleteActivityMappingModal(false);
  };

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");
  // const [editButtonName, setEditButtonName] = useState("Submit");

  const onClickDeleteActivityMapping = async () => {
    // let res = await removeBinAllocation(
    //   warehouseIdSelected?.value,
    //   ActivityMappingData.itemId,
    //   ActivityMappingData.zoneId,
    //   ActivityMappingData.locationId,
    //   jwtToken
    // );
    // if (res.status) {
    //   getReturns(warehouseIdSelected?.value, jwtToken);
    //   setOpenDeleteActivityMappingModal(false);
    // }
    // if (!res.status) {
    //   setDeleteErrorMsg(res.data.response.data.msg);
    //   setIsErrorDeleteActivityMapping(true);
    // }
  };

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const data = getRelationLocationReducer.locations?.data || [];
  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };
  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res = await uploadForReturnsValue(formData, jwtToken);

      if (res?.status === true || res?.data?.status === true) {
        getReturns(dppIdSelectedForGlobalFilter?.value, jwtToken);
        setUploadCsvFilter(false);
      }

      showUploadNotification(res);
    } catch (error) {
      showUploadNotification(error);
    }
  };


    const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  const subModuleId = "6e1939a2-039d-4a29-8e00-728b8bfed0aa";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  // let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);
  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getReturns(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox color="text" px={2} ml={-2} mb={4}>
                {allocateAccess && (
                  <Tooltip>
                    <CreateButton
                      tooltip="Add Return"
                      color="info"
                      variant="contained"
                      type="button"
                      iconOnly
                      onClick={(event) => {
                        handleAllocateItemModal();
                        getWarehouses(jwtToken);
                        getItemMaster(jwtToken);
                        getAcn(jwtToken);
                        getRelationLocation(jwtToken);
                      }}
                      style={{ borderRadius: "5px" }}
                      size="small"
                    >
                      <Icon>add</Icon>
                    </CreateButton>
                  </Tooltip>
                )}

                <CSVLink {...csvLink}>
                  <DownloadDataButton
                    tooltip="Download Returns List"
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadDataButton>
                </CSVLink>

                {
                  //  uploadFG &&
                  <UploadButton
                    tooltip="Upload CSV"
                    //   disabled={!uploadItem}
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="info"
                    iconOnly
                    onClick={uploadCsvFilterHandler}
                  >
                    <Icon>upload</Icon>
                  </UploadButton>
                }

                <CSVLink {...csvLink2}>
                  <DownloadButton
                    tooltip="Download Template"
                    style={{ marginLeft: "1rem" }}
                    type="button"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadButton>
                </CSVLink>
                {/* <Tooltip title="Upload CSV">
                    <MDButton
                      style={{ marginLeft: "1rem" }}
                      // disabled={!uploadItem}
                      type="button"
                      variant="outlined"
                      color="info"
                      iconOnly
                      onClick={uploadCsvFilterHandler}
                    >
                      <Icon>upload</Icon>
                    </MDButton>
                  </Tooltip> */}
              </MDBox>
            </MDBox>

            {uploadCsvFilter && (
              <div style={{ marginLeft: "1", marginTop: "0.5rem" }}>
                <div>
                  <input
                    className="choose_file"
                    style={{
                      marginTop: "1.5rem",
                      marginLeft: "1.5rem",
                      // marginBottom: "-9rem",
                    }}
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  />
                  <MDButton
                    disabled={
                      !uploadCsvData?.name || uploadCsvData?.type !== "text/csv"
                    }
                    variant="contained"
                    color="info"
                    style={{
                      marginLeft: { xs: "1.5rem", lg: "1" },
                      marginTop: "0rem",
                    }}
                    type="button"
                    onClick={uploadCsvHandler}
                  >
                    UPLOAD
                  </MDButton>
                </div>
                <div style={{ marginBottom: "-20px" }}>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginLeft: "30px",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>*</strong> Please upload
                    <strong>".csv"</strong> file only
                  </span>
                </div>
              </div>
            )}
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                  // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            <MDBox pt={0}>
              {loadingForDynamicColumn && (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  options={{ draggable: false }}
                  // serverSidePagination={true}
                  // paginationObj={paginationObj}
                  // pageNoValue={pageNo}
                  // rowsPerPageValue={rowsPerPage}
                  // pageNoProp={importPageNo}
                  // rowsPerPageProp={importRowsPerPage}
                  // searchProp={importSearch}
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              )}
            </MDBox>
            <Modal
              open={openDeleteModal}
              onClose={handleCloseDeleteModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ marginLeft: "0.5rem" }}
                    color="error"
                    onClick={deleteTripNo}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                  <MDBox mt={2}>
                    <Collapse in={isErrorDeleteAssembly}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDeleteAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForAssembly}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessForAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox>
                      <Grid container spacing={1}>
                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography variant="h6">DPP Code</MDTypography>
                            <MDInput
                              type="text"
                              name="DPPID"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.DPPID}
                              error={
                                formikForUpdate.touched.DPPID &&
                                formikForUpdate.errors.DPPID &&
                                true
                              }
                              disabled={true}
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.DPPID &&
                              formikForUpdate.errors.DPPID && (
                                <TextError msg={formikForUpdate.errors.DPPID} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Return Date
                            </MDTypography>
                            <MDInput
                              type="date"
                              name="ReturnDate"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ReturnDate}
                              error={
                                formikForUpdate.touched.ReturnDate &&
                                formikForUpdate.errors.ReturnDate &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ReturnDate &&
                              formikForUpdate.errors.ReturnDate && (
                                <TextError
                                  msg={formikForUpdate.errors.ReturnDate}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1} mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              {" "}
                              Return Code{" "}
                            </MDTypography>

                            <Select
                              // isDisabled={activityIdSelected ? false : true}
                              isClearable
                              className="select-css"
                              maxMenuHeight={130}
                              placeholder="Choose one..."
                              name="ReturnCode"
                              onBlur={() => {
                                formikForUpdate.handleBlur({
                                  target: { name: "ReturnCode" },
                                });
                              }}
                              value={returnCodeUpdateSelected}
                              options={activeReasonOptions}
                              onChange={(selectedOption) => {
                                handleChangeReturnUpdateCode(selectedOption);
                                // getZonesByWarehouse(selectedOption?.value);
                                formikForUpdate.setFieldValue(
                                  "ReturnCode",
                                  selectedOption
                                );
                              }}
                            />
                            {formikForUpdate.touched.ReturnCode &&
                              formikForUpdate.errors.ReturnCode && (
                                <TextError
                                  msg={formikForUpdate.errors.ReturnCode}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              {" "}
                              Repair Center{" "}
                            </MDTypography>

                            <Select
                              // isDisabled={activityIdSelected ? false : true}
                              isClearable
                              className="select-css"
                              maxMenuHeight={330}
                              placeholder="Choose one..."
                              name="RepairCenter"
                              onBlur={() => {
                                formikForUpdate.handleBlur({
                                  target: { name: "RepairCenter" },
                                });
                              }}
                              value={RepairCenterSelectedUpdate}
                              options={repairCenterOptions}
                              onChange={(selectedOption) => {
                                handleChangeRepairCenterUpdate(selectedOption);
                                // getZonesByWarehouse(selectedOption?.value);
                                formikForUpdate.setFieldValue(
                                  "RepairCenter",
                                  selectedOption
                                );
                              }}
                            />
                            {formikForUpdate.touched.RepairCenter &&
                              formikForUpdate.errors.RepairCenter && (
                                <TextError msg={formikForUpdate.errors.RepairCenter} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1} mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              {" "}
                              Repair Status{" "}
                            </MDTypography>

                            <Select
                              // isDisabled={activityIdSelected ? false : true}
                              isClearable
                              className="select-css"
                              maxMenuHeight={130}
                              placeholder="Choose one..."
                              name="RepairStatus"
                              onBlur={() => {
                                formikForUpdate.handleBlur({
                                  target: { name: "RepairStatus" },
                                });
                              }}
                              value={returnStatusSelected}
                              options={activeDataOptions}
                              onChange={(selectedOption) => {
                                handleChangeReturnStatus(selectedOption);
                                getZonesByWarehouse(selectedOption?.value);
                                formikForUpdate.setFieldValue(
                                  "RepairStatus",
                                  selectedOption
                                );
                              }}
                            />
                            {formikForUpdate.touched.RepairStatus &&
                              formikForUpdate.errors.RepairStatus && (
                                <TextError
                                  msg={formikForUpdate.errors.RepairStatus}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Final Disposition
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="FinalDisposition"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.FinalDisposition}
                              error={
                                formikForUpdate.touched.FinalDisposition &&
                                formikForUpdate.errors.FinalDisposition &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.FinalDisposition &&
                              formikForUpdate.errors.FinalDisposition && (
                                <TextError
                                  msg={formikForUpdate.errors.FinalDisposition}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox >
                            <MDTypography variant="h6">
                              Average RepairTime
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="averageRepairTime"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.averageRepairTime}
                              error={
                                formikForUpdate.touched.averageRepairTime &&
                                formikForUpdate.errors.averageRepairTime &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.averageRepairTime &&
                              formikForUpdate.errors.averageRepairTime && (
                                <TextError
                                  msg={formikForUpdate.errors.averageRepairTime}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Spareparts Availability
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="sparePartsAvailability"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.sparePartsAvailability}
                              error={
                                formikForUpdate.touched.sparePartsAvailability &&
                                formikForUpdate.errors.sparePartsAvailability &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.sparePartsAvailability &&
                              formikForUpdate.errors.sparePartsAvailability && (
                                <TextError
                                  msg={formikForUpdate.errors.sparePartsAvailability}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Common Repairs
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="commonRepairs"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.commonRepairs}
                              error={
                                formikForUpdate.touched.commonRepairs &&
                                formikForUpdate.errors.commonRepairs &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.commonRepairs &&
                              formikForUpdate.errors.commonRepairs && (
                                <TextError
                                  msg={formikForUpdate.errors.commonRepairs}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox >
                            <MDTypography variant="h6">
                              Maintenance Schedule
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="maintenanceSchedule"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.maintenanceSchedule}
                              error={
                                formikForUpdate.touched.maintenanceSchedule &&
                                formikForUpdate.errors.maintenanceSchedule &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.maintenanceSchedule &&
                              formikForUpdate.errors.maintenanceSchedule && (
                                <TextError
                                  msg={formikForUpdate.errors.maintenanceSchedule}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1} mb={2}>
                            <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                              Second Life Suitability
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={130}
                              placeholder="Choose one..."
                              name="isSecondLifeSuitable"
                              onBlur={() => formikForUpdate.setFieldTouched("isSecondLifeSuitable", true)}
                              value={formikForUpdate.values.isSecondLifeSuitable}
                              options={suitabilityOptions}
                              onChange={(selectedOption) => {
                                formikForUpdate.setFieldValue("isSecondLifeSuitable", selectedOption);
                                formikForUpdate.setFieldValue("secondLifeDurationNumber", "");
                                formikForUpdate.setFieldValue("reuseDeclarationFile", null);
                              }}
                              menuPortalTarget={document.body}
                              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            />
                            {formikForUpdate.touched.isSecondLifeSuitable && formikForUpdate.errors.isSecondLifeSuitable && (
                              <TextError msg={formikForUpdate.errors.isSecondLifeSuitable} />
                            )}
                          </MDBox>
                        </Grid>

                        {formikForUpdate.values.isSecondLifeSuitable?.value === 1 && (
                          <>
                            <Grid item xs={12} lg={4}>
                              <MDBox ml={1} mb={2}>
                                <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                                  Second Life Duration
                                </MDTypography>
                                <MDInput
                                  type="number"
                                  name="secondLifeDurationNumber"
                                  placeholder="e.g. 2"
                                  fullWidth
                                  autoComplete="off"
                                  onBlur={formikForUpdate.handleBlur}
                                  onChange={formikForUpdate.handleChange}
                                  value={formikForUpdate.values.secondLifeDurationNumber}
                                  error={
                                    formikForUpdate.touched.secondLifeDurationNumber &&
                                    formikForUpdate.errors.secondLifeDurationNumber &&
                                    true
                                  }
                                  inputProps={{ style: { height: "10px" } }}
                                />
                                {formikForUpdate.touched.secondLifeDurationNumber && formikForUpdate.errors.secondLifeDurationNumber && (
                                  <TextError msg={formikForUpdate.errors.secondLifeDurationNumber} />
                                )}
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} lg={4}>
                              <MDBox ml={1} mb={2}>
                                <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                                  Duration Unit
                                </MDTypography>
                                <Select
                                  isClearable={false}
                                  className="select-css"
                                  maxMenuHeight={130}
                                  name="secondLifeDurationUnit"
                                  value={formikForUpdate.values.secondLifeDurationUnit}
                                  options={durationUnitOptions}
                                  onBlur={() => formikForUpdate.setFieldTouched("secondLifeDurationUnit", true)}
                                  onChange={(selectedOption) => formikForUpdate.setFieldValue("secondLifeDurationUnit", selectedOption)}
                                  menuPortalTarget={document.body}
                                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                />
                                {formikForUpdate.touched.secondLifeDurationUnit && formikForUpdate.errors.secondLifeDurationUnit && (
                                  <TextError msg={formikForUpdate.errors.secondLifeDurationUnit} />
                                )}
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} lg={4}>
                              <MDBox ml={1} mb={2}>
                                <MDTypography variant="h6" fontWeight={500} mb={0}>
                                  Reuse Declaration <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span>
                                </MDTypography>

                                <MDBox width="100%">
                                  <input
                                    id="upload-reuse-file-update"
                                    type="file"
                                    accept=".png,.jpg,.jpeg,.pdf"
                                    hidden
                                    onChange={(e) => {
                                      const file = e.currentTarget.files[0];
                                      if (!file) return;

                                      const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "application/pdf"];

                                      if (!allowedTypes.includes(file.type)) {
                                        formikForUpdate.setFieldError("reuseDeclarationFile", "Only PNG, JPG, JPEG, and PDF are allowed.");
                                        formikForUpdate.setFieldValue("reuseDeclarationFile", null);
                                        e.target.value = "";
                                        return;
                                      }

                                      formikForUpdate.setFieldError("reuseDeclarationFile", "");
                                      formikForUpdate.setFieldValue("reuseDeclarationFile", file);
                                    }}
                                  />

                                  {!formikForUpdate.values.reuseDeclarationFile ? (
                                    <label htmlFor="upload-reuse-file-update" style={{ display: "block", width: "100%", }}>
                                      <MDButton
                                        variant="outlined"
                                        component="span"
                                        color="info"
                                        fullWidth
                                        sx={{
                                          height: "34px",
                                          minHeight: "34px",
                                          maxHeight: "34px",
                                          padding: "4px 16px",
                                          boxSizing: "border-box",
                                          fontSize: "0.85rem",
                                        }}
                                      >
                                        Choose File
                                      </MDButton>
                                    </label>
                                  ) : (
                                    <label htmlFor="upload-reuse-file-update" style={{ width: "100%", cursor: "pointer", display: "block", marginTop: "6px" }}>
                                      <MDBox
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        px={1.5}
                                        sx={{
                                          height: "32.5px",
                                          border: "1px dashed #1A73E8",
                                          borderRadius: "8px",
                                          backgroundColor: "#fff",
                                          boxSizing: "border-box",
                                          transition: "background-color 0.2s",
                                          "&:hover": { backgroundColor: "#f8f9fa" },
                                        }}
                                      >
                                        <MDTypography
                                          variant="body2"
                                          color="text"
                                          sx={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            flex: 1,
                                            fontSize: "14px",
                                            mr: 1,
                                          }}
                                          title={formikForUpdate.values.reuseDeclarationFile.name}
                                        >
                                          {formikForUpdate.values.reuseDeclarationFile.name}
                                        </MDTypography>
                                        <Icon fontSize="small" color="info">edit</Icon>
                                      </MDBox>
                                    </label>
                                  )}
                                </MDBox>

                                {/* Error Display */}
                                {formikForUpdate.errors.reuseDeclarationFile && (
                                  <MDTypography variant="caption" color="error" mt={0.5} display="block">
                                    {formikForUpdate.errors.reuseDeclarationFile}
                                  </MDTypography>
                                )}
                              </MDBox>
                            </Grid>
                          </>
                        )}

                        <Grid item xs={12} lg={12}>
                          <MDBox>
                            <MDTypography variant="h6">
                              Remark
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="remark"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.remark}
                              error={
                                formikForUpdate.touched.remark &&
                                formikForUpdate.errors.remark &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "40px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.remark &&
                              formikForUpdate.errors.remark && (
                                <TextError
                                  msg={formikForUpdate.errors.remark}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={12} mt={1}>
                          <MDBox mb={2}>
                            <MDTypography variant="h6">
                              Repair Actions
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="RepairActions"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.RepairActions}
                              error={
                                formikForUpdate.touched.RepairActions &&
                                formikForUpdate.errors.RepairActions &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "40px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.RepairActions &&
                              formikForUpdate.errors.RepairActions && (
                                <TextError
                                  msg={formikForUpdate.errors.RepairActions}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={12}>
                          <MDBox mb={2}>
                            <MDTypography variant="h6">
                              Reused Parts
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="ReusedParts"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ReusedParts}
                              error={
                                formikForUpdate.touched.ReusedParts &&
                                formikForUpdate.errors.ReusedParts &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "40px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ReusedParts &&
                              formikForUpdate.errors.ReusedParts && (
                                <TextError
                                  msg={formikForUpdate.errors.ReusedParts}
                                />
                              )}
                          </MDBox>
                        </Grid>


                        <Grid item xs={12}>
                          <MDBox>
                            <Collapse in={isErrorForUpdate}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsErrorForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                {errorMsgForUpdate}
                              </Alert>
                            </Collapse>
                            <Collapse in={isSuccessForUpdate}>
                              <Alert
                                severity="success"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsSuccessForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                Updated successfully
                              </Alert>
                            </Collapse>
                          </MDBox>
                        </Grid>
                        {/* <MDBox mt={3} ml={10}> */}

                        {/* <MDButton
                          // variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton> */}

                        {/* Submit Button */}
                        <MDButton
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Return & Repair Record
                  </MDTypography>
                  <MDBox>
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginRight: "10px",
                            marginTop: "4px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseAllocateItemModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container>


                      <Grid item xs={12} lg={4}>
                        <MDBox mb={2} >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            DPP Code{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={200}
                            placeholder="Choose one..."
                            name="DPPID"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "DPPID" },
                              });
                            }}
                            value={dppIdSelected}
                            options={dppOptions}
                            onChange={(selectedOption) => {
                              handleChangeDpp(selectedOption);
                              // getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue("DPPID", selectedOption);
                            }}
                          />
                          {formik.touched.DPPID && formik.errors.DPPID && (
                            <TextError msg={formik.errors.DPPID} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Return Date</MDTypography>

                          <MDInput
                            type="date"
                            name="ReturnDate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.ReturnDate}
                            error={
                              formik.touched.ReturnDate &&
                              formik.errors.ReturnDate &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              min: today, // Cannot select past date
                            }}
                          />
                          {formik.touched.ReturnDate &&
                            formik.errors.ReturnDate && (
                              <TextError msg={formik.errors.ReturnDate} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox ml={1} mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Return Code{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="ReturnCode"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "ReturnCode" },
                              });
                            }}
                            value={returnCodeSelected}
                            options={activeReasonOptions}
                            onChange={(selectedOption) => {
                              handleChangeReturnCode(selectedOption);
                              // getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue(
                                "ReturnCode",
                                selectedOption
                              );
                            }}
                          />
                          {formik.touched.ReturnCode &&
                            formik.errors.ReturnCode && (
                              <TextError msg={formik.errors.ReturnCode} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4}>
                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Repair Center{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={330}
                            placeholder="Choose one..."
                            name="RepairCenter"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "RepairCenter" },
                              });
                            }}
                            value={RepairCenterSelected}
                            options={repairCenterOptions}
                            onChange={(selectedOption) => {
                              handleChangeRepairCenter(selectedOption);
                              // getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue(
                                "RepairCenter",
                                selectedOption
                              );
                            }}
                          />
                          {formik.touched.RepairCenter &&
                            formik.errors.RepairCenter && (
                              <TextError msg={formik.errors.RepairCenter} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox ml={1} mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Repair Status{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="RepairStatus"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "RepairStatus" },
                              });
                            }}
                            value={warehouseIdSelected}
                            options={activeDataOptions}
                            onChange={(selectedOption) => {
                              handleChangeWarehouse(selectedOption);
                              getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue(
                                "RepairStatus",
                                selectedOption
                              );
                            }}
                          />
                          {formik.touched.RepairStatus &&
                            formik.errors.RepairStatus && (
                              <TextError msg={formik.errors.RepairStatus} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Final Disposition
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="FinalDisposition"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.FinalDisposition}
                            error={
                              formik.touched.FinalDisposition &&
                              formik.errors.FinalDisposition &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.FinalDisposition &&
                            formik.errors.FinalDisposition && (
                              <TextError msg={formik.errors.FinalDisposition} />
                            )}
                        </MDBox>
                      </Grid>
                      {/* <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Repair Centers
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="repairCenters"
                              fullWidth
                              autoComplete="off"
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.repairCenters}
                              error={
                                formik.touched.repairCenters &&
                                formik.errors.repairCenters &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formik.touched.repairCenters &&
                              formik.errors.repairCenters && (
                                <TextError
                                  msg={formik.errors.repairCenters}
                                />
                              )}
                          </MDBox>
                        </Grid> */}
                      <Grid item xs={12} lg={4}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">
                            Average RepairTime
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="averageRepairTime"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.averageRepairTime}
                            error={
                              formik.touched.averageRepairTime &&
                              formik.errors.averageRepairTime &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.averageRepairTime &&
                            formik.errors.averageRepairTime && (
                              <TextError
                                msg={formik.errors.averageRepairTime}
                              />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4}>
                        <MDBox ml={1} mb={2}>
                          <MDTypography variant="h6">
                            SpareParts Availability
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="sparePartsAvailability"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.sparePartsAvailability}
                            error={
                              formik.touched.sparePartsAvailability &&
                              formik.errors.sparePartsAvailability &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.sparePartsAvailability &&
                            formik.errors.sparePartsAvailability && (
                              <TextError
                                msg={formik.errors.sparePartsAvailability}
                              />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4}>
                        <MDBox ml={1} mb={2}>
                          <MDTypography variant="h6">
                            Common Repairs
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="commonRepairs"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.commonRepairs}
                            error={
                              formik.touched.commonRepairs &&
                              formik.errors.commonRepairs &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.commonRepairs &&
                            formik.errors.commonRepairs && (
                              <TextError
                                msg={formik.errors.commonRepairs}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">
                            Maintenance Schedule
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="maintenanceSchedule"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.maintenanceSchedule}
                            error={
                              formik.touched.maintenanceSchedule &&
                              formik.errors.maintenanceSchedule &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.maintenanceSchedule &&
                            formik.errors.maintenanceSchedule && (
                              <TextError
                                msg={formik.errors.maintenanceSchedule}
                              />
                            )}
                        </MDBox>

                      </Grid>



                      <Grid item xs={12} lg={4}>
                        <MDBox ml={1} mb={2}>
                          <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                            Second Life Suitability
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="isSecondLifeSuitable"
                            onBlur={() => formik.handleBlur({ target: { name: "isSecondLifeSuitable" } })}
                            value={formik.values.isSecondLifeSuitable}
                            options={suitabilityOptions}
                            onChange={(selectedOption) => {
                              formik.setFieldValue("isSecondLifeSuitable", selectedOption);
                              formik.setFieldError("isSecondLifeSuitable", "");
                              formik.setFieldValue("secondLifeDurationNumber", "");
                              formik.setFieldValue("reuseDeclarationFile", null);
                            }}
                          />
                          {formik.touched.isSecondLifeSuitable && formik.errors.isSecondLifeSuitable && (
                            <TextError msg={formik.errors.isSecondLifeSuitable} />
                          )}
                        </MDBox>
                      </Grid>

                      {formik.values.isSecondLifeSuitable?.value === 1 && (
                        <>
                          <Grid item xs={12} lg={4}>
                            <MDBox ml={1} mb={2}>
                              <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                                Second Life Duration
                              </MDTypography>
                              <MDInput
                                type="number"
                                name="secondLifeDurationNumber"
                                placeholder="e.g. 2"
                                fullWidth
                                autoComplete="off"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.secondLifeDurationNumber}
                                error={formik.touched.secondLifeDurationNumber && Boolean(formik.errors.secondLifeDurationNumber)}
                                inputProps={{ style: { height: "10px" } }}
                              />
                              {formik.touched.secondLifeDurationNumber && formik.errors.secondLifeDurationNumber && (
                                <TextError msg={formik.errors.secondLifeDurationNumber} />
                              )}
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={4}>
                            <MDBox ml={1} mb={2}>
                              <MDTypography variant="h6" style={{ fontWeight: "500" }}>
                                Duration Unit
                              </MDTypography>
                              <Select
                                isClearable={false}
                                className="select-css"
                                maxMenuHeight={130}
                                name="secondLifeDurationUnit"
                                value={formik.values.secondLifeDurationUnit}
                                options={durationUnitOptions}
                                onBlur={() => formik.handleBlur({ target: { name: "secondLifeDurationUnit" } })}
                                onChange={(selectedOption) => formik.setFieldValue("secondLifeDurationUnit", selectedOption)}
                              />
                              {formik.touched.secondLifeDurationUnit && formik.errors.secondLifeDurationUnit && (
                                <TextError msg={formik.errors.secondLifeDurationUnit} />
                              )}
                            </MDBox>
                          </Grid>

                          <Grid item xs={12} lg={4}>
                            <MDBox ml={1} mb={2}>
                              <MDTypography variant="h6" fontWeight={500}>
                                Reuse Declaration
                                {/* <span style={{ display: "inline-block", transform: "scale(0.9)", color: "red" }}>*</span> */}
                              </MDTypography>

                              <MDBox width="100%">
                                <input
                                  id="upload-reuse-file"
                                  type="file"
                                  accept=".png,.jpg,.jpeg,.pdf"
                                  hidden
                                  onChange={(e) => {
                                    const file = e.currentTarget.files[0];
                                    if (!file) return;

                                    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "application/pdf"];

                                    if (!allowedTypes.includes(file.type)) {
                                      formik.setFieldError("reuseDeclarationFile", "Only PNG, JPG, JPEG, and PDF are allowed.");
                                      formik.setFieldValue("reuseDeclarationFile", null);
                                      e.target.value = "";
                                      return;
                                    }

                                    formik.setFieldError("reuseDeclarationFile", "");
                                    formik.setFieldValue("reuseDeclarationFile", file);
                                  }}
                                />

                                {!formik.values.reuseDeclarationFile ? (
                                  <label htmlFor="upload-reuse-file" style={{ display: "block", width: "100%", }}>
                                    <MDButton
                                      variant="outlined"
                                      component="span"
                                      color="info"
                                      fullWidth
                                      sx={{
                                        height: "32.5px",
                                        minHeight: "32.5px",
                                        maxHeight: "32.5px",
                                        padding: "4px 16px",
                                        boxSizing: "border-box",
                                        fontSize: "0.85rem",
                                      }}
                                    >
                                      Choose File
                                    </MDButton>
                                  </label>
                                ) : (
                                  <label htmlFor="upload-reuse-file" style={{ width: "100%", cursor: "pointer", display: "block", }}>
                                    <MDBox
                                      display="flex"
                                      justifyContent="space-between"
                                      alignItems="center"
                                      px={1.5}
                                      sx={{
                                        height: "32.5px",
                                        border: "1px dashed #1A73E8",
                                        borderRadius: "8px",
                                        backgroundColor: "#fff",
                                        boxSizing: "border-box",
                                        transition: "background-color 0.2s",
                                        "&:hover": { backgroundColor: "#f8f9fa" },
                                      }}
                                    >
                                      <MDTypography
                                        variant="body2"
                                        color="text"
                                        sx={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          flex: 1,
                                          fontSize: "14px",
                                          mr: 1,
                                        }}
                                        title={formik.values.reuseDeclarationFile.name}
                                      >
                                        {formik.values.reuseDeclarationFile.name}
                                      </MDTypography>
                                      <Icon fontSize="small" color="info">edit</Icon>
                                    </MDBox>
                                  </label>
                                )}
                              </MDBox>

                              {formik.errors.reuseDeclarationFile && formik.touched.reuseDeclarationFile && (
                                <MDTypography variant="caption" color="error" mt={0.5} display="block">
                                  {formik.errors.reuseDeclarationFile}
                                </MDTypography>
                              )}
                            </MDBox>
                          </Grid>
                        </>
                      )}


                      <Grid item xs={12} lg={12}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">
                            Remark
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="remark"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.remark}
                            error={
                              formik.touched.remark &&
                              formik.errors.remark &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.remark &&
                            formik.errors.remark && (
                              <TextError
                                msg={formik.errors.remark}
                              />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={12}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">
                            Repair Actions
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="RepairActions"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.RepairActions}
                            error={
                              formik.touched.RepairActions &&
                              formik.errors.RepairActions &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "40px",
                              },

                              maxLength: 45,
                            }}
                          />
                          {formik.touched.RepairActions &&
                            formik.errors.RepairActions && (
                              <TextError msg={formik.errors.RepairActions} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={12}>
                        <MDBox mb={2}>
                          <MDTypography variant="h6">Reused Parts</MDTypography>
                          <MDInput
                            type="text"
                            name="ReusedParts"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.ReusedParts}
                            error={
                              formik.touched.ReusedParts &&
                              formik.errors.ReusedParts &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "40px",
                              },

                              maxLength: 45,
                            }}
                          />
                          {formik.touched.ReusedParts &&
                            formik.errors.ReusedParts && (
                              <TextError msg={formik.errors.ReusedParts} />
                            )}
                        </MDBox>
                      </Grid>


                      <Grid item xs={12} mt={2}>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created Successfully
                          </Alert>
                        </Collapse>
                      </Grid>

                      {/* Submit Button */}
                      <MDButton
                        color="info"
                        fullWidth
                        type="submit"
                        disabled={allocateButtonName === "Please wait..."}
                      >
                        {allocateButtonName}
                      </MDButton>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {/* <Footer /> */}
    </div>
    // </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    warehouses: state.warehouses,
    getReturnsReducer: state.getReturnsReducer,
    itemMaster: state.itemMaster,
    zonesByWarehouse: state.zonesByWarehouse,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,
    getAcnReducer: state.getAcnReducer,
    openBinsByWarehouse: state.openBinsByWarehouse,
    getRelationLocationReducer: state.getRelationLocationReducer,
    getWarehouseByMovementReducer: state.getWarehouseByMovementReducer,
    getDppDocumentsImageReducer: state.getDppDocumentsImageReducer,
    levelsByWarehouseReducer: state.levelsByWarehouseReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
    getDPPReducer: state.getDPPReducer,
    getRepairCenterReducer: state.getRepairCenterReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getReturns: (dppId, jwtToken) => dispatch(getReturns(dppId, jwtToken)),
    getDppIds: (jwtToken) => dispatch(getDppIds(jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getZonesByWarehouse: (id, jwtToken) =>
      dispatch(getZonesByWarehouse(id, jwtToken)),
    getLevel1ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(warehouseId, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getAcn: (jwtToken) => dispatch(getAcn(jwtToken)),
    getOpenBinsByWarehouseAndZone: (id, zoneId, jwtToken) =>
      dispatch(getOpenBinsByWarehouseAndZone(id, zoneId, jwtToken)),
    createReturns: (payload, jwtToken) =>
      dispatch(createReturns(payload, jwtToken)),
    deleteReturn: (returnId, jwtToken) =>
      dispatch(deleteReturn(returnId, jwtToken)),
    uploadForReturnsValue: (payload, jwtToken) =>
      dispatch(uploadForReturnsValue(payload, jwtToken)),
    getRelationLocation: (jwtToken) => dispatch(getRelationLocation(jwtToken)),
    getWarehousesByMovement: (activityIdSelected, jwtToken) =>
      dispatch(getWarehousesByMovement(activityIdSelected, jwtToken)),
    editReturns: (payload, jwtToken) =>
      dispatch(editReturns(payload, jwtToken)),
    getRepairCenter: (jwtToken) =>
      dispatch(getRepairCenter(jwtToken)),
    getLevelsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLevelsByWarehouse(warehouseId, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
    getDppDocumentsImage: (moduleName, type, name, jwtToken) =>
      dispatch(getDppDocumentsImage(moduleName, type, name, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Returns);
